import styled from 'styled-components';

const AccordionStyle = styled.section`
    display: flex;
    flex-direction: column;
    align-items: start;
    overflow: hidden;
    max-width: 1024px;
    margin: 0 auto;

    padding: 0 32px;
    padding-bottom: 90px;

    .faq-accordion {
        width: 100%;
    }

    .faq-item {
        padding: 18px 0;
        margin-bottom: 6px;
        width: 100%;
    }

    .faq-question {
        background: transparent;
        border: none;
        width: 100%;
        padding: 0;

        display: flex;
        justify-content: space-between;
        align-items: center;

        cursor: pointer;
        font-size: 20px;
        font-weight: 600;
        color: #111111; /* Same as blog title gray/black */

        .faq-icon {
            font-size: 28px;
            font-weight: bold;
            opacity: 0.5;
            transition: transform 0.3s ease, opacity 0.3s ease;
        }

        &[aria-expanded='true'] .faq-icon {
            transform: rotate(180deg);
            opacity: 1;
        }
    }

    /* Answer container */
    .faq-content {
        overflow: hidden;
        transition: max-height 0.35s ease, opacity 0.25s ease;
    }

    /* Actual text */
    .faq-answer {
        margin-top: 12px;
        font-size: 16px;
        color: #515151; /* matches blog text-gray */
        line-height: 1.65;

        p {
            margin-bottom: 14px;
        }

        ul,
        ol {
            margin-left: 24px;
            margin-bottom: 14px;
        }

        li {
            list-style-type: disc;
            margin-bottom: 6px;
        }
    }

    /* Responsive adjustments */
    @media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
        padding: 0 16px 70px;

        .faq-question {
            font-size: 18px;
            .faq-icon {
                font-size: 24px;
            }
        }

        .faq-answer {
            font-size: 15px;
        }
    }
`;

export default AccordionStyle;
